/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Outlet, Link } from "react-router-dom";
import Banner from "./banner";
import Pagination from "./pagination";
import config from "../config/config";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Video from "yet-another-react-lightbox/plugins/video";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import * as DOMPurify from "dompurify";
import Header from "./header";
import Fotter from "./fotter";

function Home() {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [image, setImage] = useState("");
  const [researchDatas, setResearchDatas] = useState([]);
  const [journalismsData, setJournalismsData] = useState([]);
  const [booksData, setBooksData] = useState([]);
  const [fictionBtns, setFictionBtns] = useState([]);
  const [nonFictionBtns, setNonFictionBtns] = useState([]);
  const [fiction, setFiction] = useState([]);
  const [nonFiction, setNonFiction] = useState([]);
  const [eventsData, setEventsData] = useState([]);
  const [newsData, setNewsData] = useState([]);

  const [gallaryData, setGallaryData] = useState([]);

  async function getBodyData() {
    var myHeaders = new Headers();

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    let data = [];
    await fetch(config.base_url + "api/highlite", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        data = JSON.parse(result);
        setTitle(data["data"][0]["title"]);
        setBody(data["data"][0]["body"]);
        setImage(config.base_url + "uploades/" + data["data"][0]["image"]);
        // setFirstName(data['data'][0]['title'][0])
        // setLastName(data['data'][0]['title'][1])
        // setBody(data['data'][0]['body'])
        // setImage(config.base_url+"uploades/"+data['data'][0]['image'])

        // DOMPurify.sanitize(data["data"][0]["title"])
      })
      .catch((error) => console.log("error", error));

    return data;
  }
  async function getResearchData() {
    var myResearch = new Headers();
    var requestOptions = {
      method: "GET",
      headers: myResearch,
      redirect: "follow",
    };
    let researchData = [];
    await fetch(config.base_url + "api/researchs", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        researchData = JSON.parse(result);
        setResearchDatas(researchData.data);
      })
      .catch((error) => console.log("error", error));

    return researchData;
  }
  async function getJournalismsData() {
    var myJournalism = new Headers();
    var requestOptions = {
      method: "GET",
      headers: myJournalism,
      redirect: "follow",
    };
    let journalismsData = [];
    await fetch(config.base_url + "api/journalisms", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        journalismsData = JSON.parse(result);
        setJournalismsData(journalismsData.data);
      })
      .catch((error) => console.log("error", error));

    return journalismsData;
  }
  async function getBooksData() {
    var myBooks = new Headers();
    var requestOptions = {
      method: "GET",
      headers: myBooks,
      redirect: "follow",
    };
    let booksData = [];
    await fetch(config.base_url + "api/books", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        booksData = JSON.parse(result);
        // setBooksBtns(JSON.parse(booksData.data[0].actions))
        setBooksData(booksData.data);

        let fiction = [];
        let nonFiction = [];
        let fictionBtns = [];
        let nonFictionBtns = [];

        booksData.data.map((item) => {
          if (item.is_fiction == "fiction") {
            fiction.push(item);
            fictionBtns.push(JSON.parse(item.actions));
          } else if (item.is_fiction == "non_fiction") {
            nonFiction.push(item);
            nonFictionBtns.push(JSON.parse(item.actions));
          }
        });

        setFiction(fiction);
        setNonFiction(nonFiction);
        setFictionBtns(fictionBtns);
        setNonFictionBtns(nonFictionBtns);
      })
      .catch((error) => console.log("error", error));

    return booksData;
  }

  function disableFiction() {
    document.getElementById("fictionArea").classList.remove("show");
    document.getElementById("fiction").classList.remove("show");
  }
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(4);
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const fictionCurrentPosts = fiction.slice(indexOfFirstPost, indexOfLastPost);
  const nonFictionCurrentPosts = nonFiction.slice(
    indexOfFirstPost,
    indexOfLastPost
  );
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [open, setOpen] = React.useState(false);

  const moment = require("moment");

  function disableArticles() {
    document.getElementById("articlesArea").classList.remove("show");
    document.getElementById("articles").classList.remove("show");
  }

  async function getNewsData() {
    var myNews = new Headers();
    var requestOptions = {
      method: "GET",
      headers: myNews,
      redirect: "follow",
    };
    let newsData = [];
    await fetch(config.base_url + "api/recent_news", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        newsData = JSON.parse(result);
        setNewsData(newsData.data);
      })
      .catch((error) => console.log("error", error));

    return newsData;
  }

  async function getEventsData() {
    var myBooks = new Headers();
    var requestOptions = {
      method: "GET",
      headers: myBooks,
      redirect: "follow",
    };
    let eventsData = [];
    await fetch(config.base_url + "api/upcoming", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        eventsData = JSON.parse(result);
        setEventsData(eventsData.data);
      })
      .catch((error) => console.log("error", error));

    return eventsData;
  }

  useEffect(() => {
    document.getElementById("fictionArea").classList.add("show");
    document.getElementById("fiction").classList.add("show");
    document.getElementById("articlesArea").classList.add("show");
    document.getElementById("articles").classList.add("show");
    getBodyData();
    getResearchData();
    getJournalismsData();
    getBooksData();
    getEventsData();
    getNewsData();
  }, []);

  return (
    <>
      <Header />
      <Banner />
      <div className="mainBody">
        <div className="container">
          <div className="row">
            <div className="col-md-9">
              <div id="poison" className="row">
                <div className="col-md-5">
                  <div className="poisonBookImage">
                    <img src={image} />
                  </div>
                </div>
                <div className="col-md-7">
                  <div className="poisonBookContent">
                    <a
                      href="https://www.amazon.com/Poison-Ivy-Elite-Colleges-Divide/dp/1620976951/ref=sr_1_1?crid=1LRZL6OEHE2HV&keywords=EVAN+MANDERY&qid=1655754457&s=books&sprefix=evan+mandery%2Cstripbooks%2C71&sr=1-1"
                      className="poisonBookTitle"
                      target="_blank"
                      dangerouslySetInnerHTML={{ __html: title }}
                    ></a>
                    <div className="poisonBookText">
                      <p dangerouslySetInnerHTML={{ __html: body }}></p>
                    </div>
                    <div className="singleBookbtns">
                      <a className="readBtn">Read</a>
                      <a className="buyBtn">Buy</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="eventArea">
                <div className="row">
                  <div className="col-md-12 col-6">
                    <div className="upComingEvent">
                      <h1 className="eventTitle  text-center">Events</h1>
                      {eventsData.map((upComingEvent, index) => (
                        <>
                          {index < 4 ? (
                            <div
                              className="singleEvent"
                              key={index + upComingEvent.date}
                            >
                              <p className="eventDate">
                                {moment(upComingEvent.date).format(
                                  "MMMM Do YYYY"
                                )}
                              </p>
                              <p
                                className="eventName position-relative"
                                dangerouslySetInnerHTML={{
                                  __html: upComingEvent.title,
                                }}
                              ></p>
                            </div>
                          ) : null}
                        </>
                      ))}
                      <div className="col-12 text-center">
                        <Link
                          to={"/event"}
                          className="eventBtn"
                          // onClick={() => eventShowMore()}
                        >
                          Show More
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 col-6">
                    <div className="recentNews">
                      <h1 className="newsTitle  text-center">Recent News</h1>
                      {newsData.map((recentNews, index) => (
                        <>
                          {index < 4 ? (
                            <div
                              className="singleNews"
                              key={index + recentNews.date}
                            >
                              <p className="newsDate">
                                {moment(recentNews.date).format("MMMM Do YYYY")}
                              </p>
                              <p
                                className="newsName position-relative"
                                dangerouslySetInnerHTML={{
                                  __html: recentNews.title,
                                }}
                              ></p>
                            </div>
                          ) : null}
                        </>
                      ))}
                      <div className="col-12 text-center">
                        <Link
                          to={"/news"}
                          className="newsBtn"
                          // onClick={() => newsShowMore()}
                        >
                          Show More
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Outlet />
            </div>

            <div className="col-md-12">
              <div className="booksArea">
                <div className="row">
                  <div className="col-md-12 text-center">
                    <h1 className="booksTitle">Books</h1>
                  </div>
                  <div className="col-md-12 text-center">
                    <div className="booksBtn">
                      <ul className="nav">
                        <li className="active">
                          <a
                            className="fictionBtn"
                            data-toggle="tab"
                            href="#fiction"
                            id="fictionArea"
                          >
                            Fiction
                          </a>
                        </li>
                        <li>
                          <a
                            className="nonFictionBtn"
                            data-toggle="tab"
                            href="#nonFiction"
                            id="non-fictionArea"
                            onClick={() => disableFiction()}
                          >
                            Non Fiction
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div id="fiction" className="tab-pane fade in active">
                      <div fictionbooks={fictionCurrentPosts} loading={loading}>
                        <div className="row">
                          {fictionCurrentPosts.map((fictionBook, index) => (
                            <div
                              className="col-md-6 col-12"
                              key={index + fictionBook.image}
                            >
                              <div className="singleBook">
                                <div className="row">
                                  <div className="col-md-4 col-4">
                                    <div className="singleBookImage">
                                      <img
                                        src={
                                          "http://api.evanmandery.com/uploades/" +
                                          fictionBook.image
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-8 col-8">
                                    <div className="singleBookContent">
                                      <a
                                        href={fictionBook.title_source_url}
                                        className="singleBookTitle"
                                        target="_blank"
                                        dangerouslySetInnerHTML={{
                                          __html: fictionBook.title,
                                        }}
                                      ></a>
                                      <p
                                        className="singleBookDetails"
                                        dangerouslySetInnerHTML={{
                                          __html: fictionBook.description,
                                        }}
                                      ></p>
                                      <div className="singleBookbtns">
                                        {fictionBtns[index].map(
                                          (fictionBtn, childIndex) => (
                                            <a
                                              href={fictionBtn.url}
                                              className="readBtn"
                                              target="_blank"
                                              key={childIndex}
                                            >
                                              {fictionBtn.name}
                                            </a>
                                          )
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <Pagination
                        postsPerPage={postsPerPage}
                        totalPosts={fiction.length}
                        paginate={paginate}
                      />
                    </div>
                    <div id="nonFiction">
                      <div
                        nonfictionbooks={nonFictionCurrentPosts}
                        loading={loading}
                      >
                        <div className="row">
                          {nonFictionCurrentPosts.map(
                            (nonFictionBook, index) => (
                              <div
                                className="col-md-6 col-12"
                                key={index + nonFictionBook.image}
                              >
                                <div className="singleBook">
                                  <div className="row">
                                    <div className="col-md-4 col-4">
                                      <div className="singleBookImage">
                                        <img
                                          src={
                                            "http://api.evanmandery.com/uploades/" +
                                            nonFictionBook.image
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-8 col-8">
                                      <div className="singleBookContent">
                                        <a
                                          href={nonFictionBook.title_source_url}
                                          className="singleBookTitle"
                                          target="_blank"
                                          dangerouslySetInnerHTML={{
                                            __html: nonFictionBook.title,
                                          }}
                                        ></a>
                                        <p
                                          className="singleBookDetails"
                                          dangerouslySetInnerHTML={{
                                            __html: nonFictionBook.description,
                                          }}
                                        ></p>
                                        <div className="singleBookbtns">
                                          {nonFictionBtns[index].map(
                                            (fictionBtn, childIndex) => (
                                              <a
                                                href={fictionBtn.url}
                                                className="readBtn"
                                                target="_blank"
                                                key={childIndex}
                                              >
                                                {fictionBtn.name}
                                              </a>
                                            )
                                          )}
                                          {nonFictionBook?.gallery?.length >
                                            0 && (
                                            <a
                                              type="button"
                                              onClick={(item) => {
                                                let galleryArray = [];
                                                nonFictionBook.gallery.map(
                                                  (galleryImg) => {
                                                    let object = {
                                                      src:
                                                        "http://api.evanmandery.com/uploades/" +
                                                        galleryImg.image,
                                                    };
                                                    galleryImg["src"] =
                                                      "http://api.evanmandery.com/uploades/" +
                                                      galleryImg.image;
                                                    galleryArray.push(
                                                      galleryImg
                                                    );
                                                  }
                                                );
                                                setGallaryData(galleryArray);
                                                setOpen(true);
                                              }}
                                            >
                                              Gallery
                                            </a>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                          )}

                          <Lightbox
                            open={open}
                            zoom={{
                              maxZoomPixelRatio: 100,
                            }}
                            close={() => setOpen(false)}
                            slides={gallaryData}
                            plugins={[
                              Captions,
                              Fullscreen,
                              Slideshow,
                              Thumbnails,
                              Video,
                              Zoom,
                            ]}
                          />
                        </div>
                      </div>

                      <Pagination
                        postsPerPage={postsPerPage}
                        totalPosts={nonFiction.length}
                        paginate={paginate}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div id="research" className="researchArea">
                <div className="row">
                  <div className="col-md-12 text-center">
                    <h1 className="researchTitle">
                      Selected Death Penalty Research
                    </h1>
                  </div>
                  <div className="col-md-12">
                    <div className="articlesArea show">
                      {researchDatas.map((researchData, index) => (
                        <div
                          className="singleJournalismInfo"
                          key={index + researchData.research_year}
                        >
                          <div className="row align-items-center">
                            <div className="col-md-5 col-5 text-center">
                              <h1
                                className="journalismProduction"
                                dangerouslySetInnerHTML={{
                                  __html: researchData.title,
                                }}
                              ></h1>
                              <p className="journalismDate">
                                {researchData.research_year}
                              </p>
                            </div>
                            <div className="col-md-7 col-7">
                              <a
                                href={researchData.description_source_url}
                                className="journalismTitle"
                                target="_blank"
                                dangerouslySetInnerHTML={{
                                  __html: researchData.description,
                                }}
                              ></a>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="journalismArea">
                <div className="col-md-12 text-center">
                  <h1 className="booksTitle">Journalism</h1>
                </div>
                <div className="col-md-12">
                  <div className="journalismBtn">
                    <ul className="nav">
                      <li>
                        <a
                          className="articlesBtn"
                          data-toggle="tab"
                          href="#articles"
                          id="articlesArea"
                        >
                          Articles
                        </a>
                      </li>
                      <li>
                        <a
                          className="opEndBtn"
                          data-toggle="tab"
                          href="#opEds"
                          id="op-edsArea"
                          onClick={() => disableArticles()}
                        >
                          Op-Eds
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="articlesArea" id="articles">
                  {journalismsData.map((journalismArticle, index) => (
                    <>
                      {journalismArticle.type == "articales" && (
                        <div
                          className="singleJournalismInfo"
                          key={index + journalismArticle.published_at}
                        >
                          <div className="row align-items-center">
                            <div className="col-md-5 col-5 text-center">
                              <h1
                                className="journalismProduction"
                                dangerouslySetInnerHTML={{
                                  __html: journalismArticle.title,
                                }}
                              ></h1>
                              <p className="journalismDate">
                                {journalismArticle.published_at}
                              </p>
                            </div>
                            <div className="col-md-7 col-7">
                              <a
                                href={journalismArticle.description_source_url}
                                className="journalismTitle"
                                target="_blank"
                                dangerouslySetInnerHTML={{
                                  __html: journalismArticle.description,
                                }}
                              ></a>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  ))}
                </div>
                <div className="opEdsArea" id="opEds">
                  {journalismsData.map((journalismOpEds, index) => (
                    <div
                      className="singleJournalismInfo"
                      key={index + journalismOpEds.title}
                    >
                      {journalismOpEds.type == "op-eds" && (
                        <div className="row align-items-center">
                          <div className="col-md-5 col-5 text-center">
                            <h1
                              className="journalismProduction"
                              dangerouslySetInnerHTML={{
                                __html: journalismOpEds.title,
                              }}
                            ></h1>
                            <p className="journalismDate">
                              {journalismOpEds.published_at}
                            </p>
                          </div>
                          <div className="col-md-7 col-7">
                            <a
                              href={journalismOpEds.description_source_url}
                              className="journalismTitle"
                              target="_blank"
                              dangerouslySetInnerHTML={{
                                __html: journalismOpEds.description,
                              }}
                            ></a>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Fotter />
    </>
  );
}

export default Home;
